import { FormInstance } from 'antd';

import {
	AdditionalWarehousesFiltersForm,
	MainWarehousesFiltersForm,
	SearchWarehousesFilters,
} from './SearchWarehouses';

export const removeEmptyValues = (formValue: SearchWarehousesFilters): SearchWarehousesFilters =>
	Object.fromEntries(
		Object.entries(formValue).filter(
			([_, value]) => value !== '' && value !== undefined && value !== null,
		),
	);

export const encodedAndFilterValues = (formValue: SearchWarehousesFilters) => {
	return Object.fromEntries(
		Object.entries(removeEmptyValues(formValue)).map(
			([key, value]) =>
				typeof value === 'string' ? [key, encodeURIComponent(value)] : [key, value], // Кодируем значения
		),
	);
};

export const fillFormValues = (params: {
	queryParams: SearchWarehousesFilters;
	mainFormValue: FormInstance<MainWarehousesFiltersForm>;
	additionalFormValue: FormInstance<AdditionalWarehousesFiltersForm>;
}) => {
	const { queryParams, mainFormValue, additionalFormValue } = params;
	mainFormValue.setFieldsValue(queryParams);
	additionalFormValue.setFieldsValue(queryParams);
};
